import { z } from 'zod';

export const featuredCollectionDuelSchema = z.object({
  duel_id: z.string().uuid(),
  slug: z.string(),
  player_a_web_name: z.string(),
  player_b_web_name: z.string(),
  total_votes: z.number().int().nonnegative(),
  sort_order: z.number().int(),
});

export type FeaturedCollectionDuel = z.infer<typeof featuredCollectionDuelSchema>;

export const featuredCollectionSchema = z.object({
  id: z.string().uuid(),
  slug: z.string(),
  name: z.string(),
  logo_url: z.string().nullable().optional(),
  creator_name: z.string().nullable().optional(),
  duel_count: z.number().int().nonnegative(),
  duels: z.array(featuredCollectionDuelSchema),
});

export type FeaturedCollection = z.infer<typeof featuredCollectionSchema>;

export const featuredCollectionsResponseSchema = z.object({
  collections: z.array(featuredCollectionSchema),
});

export type FeaturedCollectionsResponse = z.infer<typeof featuredCollectionsResponseSchema>;

export type ViewMode =
  | { type: 'all' }
  | { type: 'featured'; collectionSlug: string }
  | { type: 'my-voted' }
  | { type: 'my-unvoted' }
  | { type: 'my-duels' };
